module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-01-4b74e3e7c2c503861f88962daa3099cc.jpg";